import { HIDE_SNACKBAR, HideSnackbarAction, SHOW_SNACKBAR, ShowSnackbarAction } from './actionType';

export const showSnackbar = (message: string): ShowSnackbarAction => ({
  type: SHOW_SNACKBAR,
  payload: { message },
});

export const hideSnackbar = (): HideSnackbarAction => ({
  type: HIDE_SNACKBAR,
});